import React, { useEffect , useState } from 'react';

const ByobCollectionCard = ({ collection, index }) => {
  const [byobContentCardSettings, setByobContentCardSettings] = useState({});

    useEffect(() => {
        console.log("BYOB Content Card Settings", window.byobContentCardSettings);
        setByobContentCardSettings(window.byobContentCardSettings);
    }, []);

    return (
      <div key={'collection-' + index} className='col-span-1 md:col-span-3  flex flex-col justify-end h-full bg-cover bg-center rounded-lg relative'
      style={{ backgroundImage: `url(${collection.collection_featured_image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="absolute bg-black inset-0  rounded-lg" style={{ opacity: (byobContentCardSettings.overlay_opacity / 100) }}></div>
        <div className='p-4 relative'>
          <h3 className=' font-bold text-xl' style={{ color: byobContentCardSettings.title_color }}>
            {collection.collection_title}
          </h3>
          <p style={{ color: byobContentCardSettings.description_color }}>
            {collection.collection_description}
          </p>
        </div>
      </div>
    )
}

export default ByobCollectionCard;